import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NGXLogger } from 'ngx-logger';
import { catchError, map, of, switchMap, tap } from 'rxjs';

import { StockToteAction } from './stock-tote.action';
import { StockToteService } from '../service/stock-tote.service';

@Injectable()
export class StockToteEffects {
  constructor(
    private actions$: Actions,
    private logger: NGXLogger,
    private stockToteService: StockToteService
  ) {}

  stockToteSummaryRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StockToteAction.stockToteSummaryRequest),
      tap((_) => this.logger.debug('@Effect [Stock Tote] Stock tote summary request ')),
      switchMap(() => {
        return this.stockToteService.summary().pipe(
          map((response) => {
            return StockToteAction.stockToteSummaryResponse({ response });
          }),
          catchError((err) => of(err))
        );
      })
    );
  });

  stockToteListRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StockToteAction.stockToteListRequest),
      tap((_) => this.logger.debug('@Effect [Stock Tote] Stock tote list request ')),
      switchMap(({ payload }) => {
        return this.stockToteService.getList({ ...payload }).pipe(
          map((response) => {
            return StockToteAction.stockToteListResponse({ response });
          }),
          catchError((err) => of(err))
        );
      })
    );
  });
}
